import { Button, SafeArea } from "antd-mobile";
import SuccessIcon from "../assets/success.svg";
import FailIcon from "../assets/fail.svg";
import style from "./index.module.scss";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { useEffect } from "react";

const ResultPage = () => {
  const { token } = useParams<{ token: string }>();
  const { status, msg } =
    useLocation<{ status: string; msg: string }>().state || {};
  const isSuccess = status === "success";
  const icon = isSuccess ? SuccessIcon : FailIcon;
  const text = isSuccess ? "提交成功" : "提交失败";
  const history = useHistory();

  const closePage = () => {
    window.open("", "_self")?.close();
    window.history.back();
  };

  useEffect(() => {
    const isVerify = () => {
      const phone = sessionStorage.getItem("phone");
      const code = sessionStorage.getItem("code");
      if (!phone || !code) {
        history.replace(`/octopus/verify/${token}`);
        return;
      }
    };
    isVerify();
  }, [history, token]);

  return (
    <div className={style.resultPage}>
      <img src={icon} className={style.resultIcon} alt="resultIcon" />
      <div className={style.resultText}>{text}</div>
      {!isSuccess && <div className={style.resultTip}>{msg}</div>}
      <div className={style.footer}>
        <Button block size="large" onClick={closePage}>
          确定
        </Button>
        <SafeArea position="bottom" />
      </div>
    </div>
  );
};

export default ResultPage;
